module.exports = __webpack_public_path__ + "static/media/icon-list-compact.44c5705d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-list-compact.svg
// module id = 1854
// module chunks = 0